// PayPal
jQuery(document).ready(function(){

    var $j = jQuery;

    $j('.paypal-form .alert').hide();

    $j('.paypal-form').each(function() {
        $j(this).submit(function() {
            var amt = '0';
            var isAmtChecked = 0;

            if ($j(this).hasClass('paypal-form-simple')) {
                amt = $j(this).find('input[name=selected_amount]').val() || '0';
            } else {
                amt = $j(this).find('input:radio[name=selected_amount]:checked').val() || '0';
                isAmtChecked = $j(this).find('input:radio[name=selected_amount]:checked').length;
            }
            // console.log('originally got '+amt);
            amt = amt.replace(/[^0-9\.]/g, '');
            // console.log('after replace i got: '+amt);
            amt = parseInt(amt);
            // console.log('i got: '+amt);
            if (isNaN(amt)) {
                amt = 0;
            }
            // console.log('i now see: '+amt);

            if (!amt > 0 && !isAmtChecked) {
                $j(this).children('.alert').slideDown();
                var target = $j(this).children('.alert').offset().top;
                $j('html,body').animate({scrollTop: target}, 1000);
                return false;
            }
            if ($j(this).hasClass('paypal-form-simple')) {
                $j(this).find('input[name=selected_amount]').val(amt);
            }
            return true;
        });
    });

});



(function() {
    function quabbinOptional(){
        return 0;
    };

    function calculateFee (originalAmount) {
        const calculatedAmount = document.getElementById('calculated_amount');
        const totalAmount = document.getElementById('total_amount');

        const totalWithFees = (originalAmount + .49) / (1 - .0199);
        const fee = totalWithFees - originalAmount;
        calculatedAmount.innerText = 
            fee.toLocaleString('en',  
            {style: 'currency', currency: 'USD', minimumFractionDigits: 2}); 
        
        totalAmount.innerText = 
            (totalWithFees).toLocaleString('en',  
            {style: 'currency', currency: 'USD', minimumFractionDigits: 2});

        return (totalWithFees).toLocaleString('en', {useGrouping:false, minimumFractionDigits: 2, maximumFractionDigits: 2});
    }

    // Make sure we have a PayPal form to calculate with.
    if (document.getElementById('calculated_amount') && document.getElementById('total_amount')) {
        calculateFee(Number(0));
    }

    // Make sure there is something to attach the listener to.
    if (document.getElementsByClassName('paypal-form').length > 0) {        

        document.getElementsByClassName('paypal-form')[0].addEventListener('input', function (e){  
            if (e.target.name === 'selected_amount' || e.target.name === 'custom_amount') {
                if (e.target.id === 'custom_amount') {
                    const customRadio = e.target.parentElement.firstElementChild;
                    customRadio.click();
                    customRadio.value = e.target.value;
                } else {
                    // Add and remove the required attribute for the custom_amount field depending on the whether 'other' radio is selected
                    /** @type {HTMLElement} */
                    const el = e.target.parentElement;
                    if (el.contains(document.getElementById('custom_amount'))) {
                        document.getElementById('custom_amount').setAttribute('required','');
                    } else {
                        document.getElementById('custom_amount').removeAttribute('required');
                    }
                }
                const checkElement = document.getElementById('calculated_amount').parentElement.parentElement.querySelector('input[type=checkbox]');
                const amountElement = document.getElementById('amount');
                const amountWithFees = calculateFee(Number(Number(e.target.value.replace(",","")) + quabbinOptional()) || 0);
                amountElement.value = checkElement.checked ? amountWithFees : (Number(Number(e.target.value.replace(",","")) + quabbinOptional()) || 0).toLocaleString('en', {useGrouping:false, minimumFractionDigits: 2, maximumFractionDigits: 2});
            } else {
                const selectedElement = document.getElementsByClassName('paypal-form')[0].querySelector('input[name=selected_amount]:checked');            
                if (selectedElement) {
                    const checkElement = document.getElementById('calculated_amount').parentElement.parentElement.querySelector('input[type=checkbox]');          
                    
                    const amountWithFees = calculateFee(Number(Number(selectedElement.value.replace(",","")) + quabbinOptional()) || 0);
                    const amountElement = document.getElementById('amount');
                    amountElement.value = checkElement.checked ? amountWithFees : (Number(Number(selectedElement.value.replace(",","")) + quabbinOptional()) || 0).toLocaleString('en', {useGrouping:false, minimumFractionDigits: 2, maximumFractionDigits: 2});
                }
            }
        });

        let isIE = false;

        // For IE
        try {
            new URLSearchParams();
            // let something = browser.browsingData.cache;
        } catch (e) {
            console.log('Stop using IE');
            isIE = true;
        }

        if (isIE || !!window.StyleMedia) {
            document.getElementsByClassName('paypal-form')[0].addEventListener('change', function(e) {
                if (e.target.name === 'selected_amount') {  
                    const checkElement = document.getElementById('calculated_amount').parentElement.parentElement.querySelector('input[type=checkbox]');              
                    const amountElement = document.getElementById('amount');
                    const amountWithFees = calculateFee(Number(Number(e.target.value.replace(",","")) + quabbinOptional()) || 0);
                    amountElement.value = checkElement.checked ? amountWithFees : (Number(Number(e.target.value.replace(",","")) + quabbinOptional()) || 0).toLocaleString('en', {useGrouping:false, minimumFractionDigits: 2, maximumFractionDigits: 2});

                    // Add and remove the required attribute for the custom_amount field depending on the whether 'other' radio is selected
                    /** @type {HTMLElement} */
                    const el = e.target.parentElement;
                    if (el.contains(document.getElementById('custom_amount'))) {
                        document.getElementById('custom_amount').setAttribute('required','');
                    } else {
                        document.getElementById('custom_amount').removeAttribute('required');
                    }
                } else { 
                    const selectedElement = document.getElementsByClassName('paypal-form')[0].querySelector('input[name=selected_amount]:checked');            
                    if (selectedElement) {
                        const checkElement = document.getElementById('calculated_amount').parentElement.parentElement.querySelector('input[type=checkbox]');          
                        const amountWithFees = calculateFee(Number(Number(selectedElement.value.replace(",","")) + quabbinOptional()) || 0);
                        const amountElement = document.getElementById('amount');
                        amountElement.value = checkElement.checked ? amountWithFees : (Number(Number(selectedElement.value.replace(",","")) + quabbinOptional()) || 0).toLocaleString('en', {useGrouping:false, minimumFractionDigits: 2, maximumFractionDigits: 2});
                    }
                }

            });
        }
    }
})();
